<div
  class="guts-m-b-2 l_flex m-l_flex"
  [ngClass]="{ 'l_flex-justify-center': isMobile }"
>
  <div class="l_flex m-l_flex l_flex-center-children">
    <h3 class="h3">{{ heading }}</h3>
    <div *ngIf="hasItems && showViewAll">
      <a
        class="color-blue par--small font-medium uhover guts-p-h-1"
        [ngClass]="{ 'guts-p-h-1': isMobile, 'guts-m-l-1-half': !isMobile }"
        [routerLink]="[viewAllUrl]"
        [queryParams]="viewAllUrlQueryParams"
        data-dgat="profile-heading-fee"
        [attr.aria-label]="viewAllAriaLabel"
        >{{ 'Core_ViewAll' | translate }}</a
      >
    </div>
  </div>

  <div
    *ngIf="ownerIsViewing"
    class="l_flex m-l_flex l_flex-center-children"
    [ngClass]="{ 'l_flex-justify-right guts-m-l-auto': !isMobile }"
  >
    <ng-content></ng-content>
  </div>
</div>
